<template>
	<div class="p-2">
		<b-row class="pb-1" v-if="!this.postura_id">
			<b-col cols="12" lg="5" md="5" class="mb-1">
				<b-button-group>
					<b-button
						@click="viewMode = 'cards'"
						:variant="viewMode === 'cards' ? 'primary' : 'outline-primary'"
						v-b-tooltip.hover="'Vista de cards'"
					>
						<feather-icon icon="GridIcon" />
					</b-button>
					<b-button
						@click="viewMode = 'table'"
						:variant="viewMode === 'table' ? 'primary' : 'outline-primary'"
						v-b-tooltip.hover="'Vista de Tabla'"
					>
						<feather-icon icon="ListIcon" />
					</b-button>
				</b-button-group>
			</b-col>
			<b-col cols="12" lg="7" md="7" class="mb-1">
				<div class="d-flex">
					<b-form-input
						@keyup.enter="init"
						v-model="searchCode"
						placeholder="Buscar por codigo de lote"
					></b-form-input>
					<b-button @click="init" class="ml-1" variant="outline-primary">Buscar</b-button>
					<b-button
						to="/encaste/lotes/crear"
						variant="outline-primary"
						@click="controllerDeadChicks = true"
						:disabled="disabledEncaste"
						class="ml-1 text-nowrap"
					>
						<feather-icon icon="PlusIcon" />
						Crear lote
					</b-button>
				</div>
			</b-col>
		</b-row>

		<!-- Cards View -->
		<div v-if="viewMode === 'cards' && !postura_id" class="lotes-cards-container">
			<div v-if="lotes.length > 0">
				<b-card v-for="(lote, index) in lotes" :key="index" class="lote-card mb-3" no-body>
					<b-card-body class="p-0">
						<div class="lote-card-header">
							<div class="lote-header-left">
								<b-button variant="flat" class="p-0" @click="toggleLoteDetails(lote.id)">
									<feather-icon
										:icon="expandedLotes.includes(lote.id) ? 'ChevronUpIcon' : 'ChevronDownIcon'"
										size="24"
									/>
								</b-button>
								<div class="lote-number-badge">
									{{ formatLoteCode(lote) }}
								</div>
								<div class="lote-info">
									<h4 class="mb-0">{{ lote.code }}</h4>
									<small class="text-uppercase text-muted">{{ lote.method }}</small>
								</div>
							</div>
							<div class="lote-header-center">
								<!-- Stats Section -->
								<div class="stats-section-header">
									<div class="stats-row">
										<div
											class="stat-badge stat-blue"
											:class="lote.ing > 0 ? 'clickable' : ''"
											@click="lote.ing > 0 ? openEggsDetailModal(lote, 'ing') : null"
										>
											<font-awesome-icon icon="fa-solid fa-egg" size="xl" class="text-info" />
											<div class="d-flex flex-column">
												<span class="ml-1">Ingresados</span>
												<span class="ml-1 font-weight-bold stat-number">{{ lote.ing }}</span>
											</div>
										</div>
										<div
											class="stat-badge stat-green"
											:class="lote.inc > 0 ? 'clickable' : ''"
											@click="lote.inc > 0 ? openEggsDetailModal(lote, 'inc') : null"
										>
											<div class="circle-indicator circle-green"></div>
											<div class="d-flex flex-column">
												<span class="ml-1">Incubando</span>
												<span class="ml-1 font-weight-bold stat-number">{{ lote.inc }}</span>
											</div>
										</div>
										<div
											v-if="lote.stage > 2"
											class="stat-badge"
											:class="getStatTrafficLightClass(lote.fer)"
										>
											<div class="d-flex flex-column">
												<span>Fertilidad</span>
												<span class="font-weight-bold stat-number">
													{{ lote.stage > 2 ? lote.fer : "---" }}
												</span>
											</div>
										</div>
										<div
											v-if="lote.stage > 3"
											class="stat-badge stat-orange"
											:class="lote.nacidos > 0 ? 'clickable' : ''"
											@click="lote.nacidos > 0 ? openEggsDetailModal(lote, 'nac') : null"
										>
											<ChickIcon color="var(--orange)" :size="20" />
											<div class="d-flex flex-column">
												<span class="ml-1">Nacidos</span>
												<span class="ml-1 font-weight-bold stat-number">
													{{ lote.stage > 3 ? lote.nacidos : "---" }}
												</span>
											</div>
										</div>
										<div
											v-if="lote.stage > 3"
											class="stat-badge stat-cyan"
											:class="lote.vivos > 0 ? 'clickable' : ''"
											@click="lote.vivos > 0 ? openAlivesDetailModal(lote) : null"
										>
											<div class="circle-indicator circle-cyan"></div>
											<div class="d-flex flex-column">
												<span class="ml-1">Vivos</span>
												<span class="ml-1 font-weight-bold stat-number">
													{{ lote.stage > 3 ? lote.vivos : "---" }}
												</span>
											</div>
										</div>
										<div
											v-if="lote.stage > 3"
											class="stat-badge stat-red"
											:class="lote.deads_lote > 0 ? 'clickable' : ''"
											@click="lote.deads_lote > 0 ? openDeadsDetailModal(lote) : null"
										>
											<v-icon name="fa-skull" scale="1" class="text-danger" />
											<div class="d-flex flex-column">
												<span class="ml-1">Muertos</span>
												<span class="ml-1 font-weight-bold stat-number">
													{{
														lote.stage > 3
															? Number(lote.deads_lote) + Number(lote.depu_total)
															: "---"
													}}
												</span>
											</div>
										</div>
										<div
											v-if="lote.stage > 3 && lote.efe != null"
											class="stat-badge"
											:class="getStatTrafficLightClass(lote.efe)"
										>
											<div class="d-flex flex-column">
												<span>Efectividad</span>
												<span class="font-weight-bold stat-number">
													{{ lote.stage > 3 ? (lote.efe ? lote.efe : "---") : "---" }}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="lote-header-right">
								<div class="date-info">
									<div>
										<small class="text-muted">Creación</small>
										<div class="font-weight-bold">{{ lote.start_date | myGlobalDayShort }}</div>
									</div>
									<div class="ml-2">
										<small class="text-muted">Nacimiento</small>
										<div v-if="lote.dob">
											<div v-if="!lote.dob_edit" class="d-flex align-items-center">
												<div class="font-weight-bold">{{ lote.dob }}</div>
												<div
													class="position-relative"
													v-if="
														lote.stages_array
															.map((item, index) => {
																if (index == lote.stages_array.length - 1) {
																	return item.status_stage_lote_id
																}
															})
															.filter((it) => it != null)[0] != 3
													"
												>
													<FeatherIcon
														@click="lote.dob_edit = true"
														icon="EditIcon"
														class="icon-clock cursor-pointer ml-50"
														color="orange"
													/>
												</div>
											</div>
											<div v-else class="d-flex justify-content-center align-items-center">
												<date-picker
													@input="editDobLote(lote.id, lote.dob)"
													format="DD-MM-YYYY"
													v-model="lote.dob"
													valueType="format"
													:formatter="momentFormat"
													:clearable="false"
													style="width: 130px"
												></date-picker>
												<FeatherIcon
													@click="lote.dob_edit = false"
													icon="XIcon"
													size="20"
													class="cursor-pointer ml-50"
													color="red"
												/>
											</div>
										</div>
										<div v-else>---</div>
									</div>
								</div>
								<!-- Stages Section -->
								<div class="stages-section-header">
									<div class="d-flex align-items-center">
										<div
											v-for="(stage, key) in lote.stages_array"
											:key="key"
											class="position-relative"
										>
											<StageLote
												:stage="stage"
												:stages="lote.stages_array"
												:index="key"
												@open-stage="openModal(stage, lote)"
											/>
											<div class="stageCommentIndicator" v-if="stage.observation"></div>
										</div>
										<FeatherIcon
											@click="clickTrackingStages(lote)"
											icon="AlignJustifyIcon"
											class="cursor-pointer"
											color="orange"
											size="24"
										/>
									</div>
								</div>
							</div>
						</div>

						<b-collapse :visible="expandedLotes.includes(lote.id)" :id="`lote-details-${lote.id}`">
							<div class="lote-card-content">
								<b-row>
									<!-- HUEVOS Card -->
									<b-col cols="12" md="6" class="mt-1">
										<b-card no-body class="details-eggs-card">
											<b-card-header class="details-card-header">
												<font-awesome-icon icon="fa-solid fa-egg" size="xl" class="text-info" />
												<span class="ml-2 font-weight-bold">HUEVOS</span>
											</b-card-header>
											<b-card-body>
												<b-row>
													<b-col cols="12" class="mb-1">
														<div class="info-item">
															<div class="info-label">Posturas (POS)</div>
															<div
																class="info-value text-primary clickable"
																@click="clickIdLote(lote)"
															>
																{{ lote.posturas }}
															</div>
														</div>
													</b-col>
													<b-col cols="12" class="mb-1">
														<div class="info-item">
															<div class="info-label">Infértiles (INF)</div>
															<div
																class="info-value"
																:class="lote.inf != '0' ? 'clickable' : ''"
																@click="
																	lote.inf != '0'
																		? openEggsDetailModal(lote, 'inf')
																		: null
																"
															>
																{{ lote.inf }}
															</div>
														</div>
													</b-col>
													<b-col cols="12">
														<div class="info-item">
															<div class="info-label">Quemados (QUE)</div>
															<div
																class="info-value"
																:class="lote.que != '0' ? 'clickable' : ''"
																@click="
																	lote.que != '0'
																		? openEggsDetailModal(lote, 'que')
																		: null
																"
															>
																{{ lote.que }}
															</div>
														</div>
													</b-col>
												</b-row>
											</b-card-body>
										</b-card>
									</b-col>

									<!-- POLLOS Card -->
									<b-col cols="12" md="6" class="mt-1">
										<b-card no-body class="details-chicks-card">
											<b-card-header class="details-card-header">
												<ChickIcon color="var(--green)" :size="20" />
												<span class="ml-2 font-weight-bold">POLLOS</span>
											</b-card-header>
											<b-card-body>
												<b-row>
													<b-col cols="12" class="mb-1">
														<div class="info-item">
															<div class="info-label">No Nacidos (NON)</div>
															<div
																class="info-value"
																:class="
																	lote.stage > 3 && lote.no_n != '0'
																		? 'clickable'
																		: ''
																"
																@click="
																	lote.stage > 3 && lote.no_n != '0'
																		? openEggsDetailModal(lote, 'no_n')
																		: null
																"
															>
																{{ lote.stage > 3 ? lote.no_n : "---" }}
															</div>
														</div>
													</b-col>
													<b-col cols="12" class="mb-1">
														<div class="info-item">
															<div class="info-label">% Incubación (% INC)</div>
															<div
																class="info-value"
																:class="
																	lote.stage > 3
																		? getTextTrafficLightClass(lote.efe_inc)
																		: ''
																"
															>
																{{ lote.stage > 3 ? lote.efe_inc : "---" }}
															</div>
														</div>
													</b-col>
												</b-row>
											</b-card-body>
										</b-card>
									</b-col>
								</b-row>
							</div>
						</b-collapse>
					</b-card-body>
				</b-card>

				<!-- Total Summary Card -->
				<b-card class="total-summary-card" no-body>
					<b-card-body class="p-0">
						<div class="total-summary-header">
							<div class="summary-header-left">
								<b-button variant="flat" class="p-0" @click="toggleTotalSummary">
									<feather-icon
										class="text-white"
										:icon="expandedTotalSummary ? 'ChevronUpIcon' : 'ChevronDownIcon'"
										size="24"
									/>
								</b-button>
								<div class="summary-icon-badge">Σ</div>
								<div class="summary-info">
									<h4 class="mb-0">TOTAL</h4>
									<small class="text-uppercase text-muted">{{ lotes.length }} LOTES</small>
								</div>
							</div>
							<div class="summary-header-center">
								<!-- Main Stats Section -->
								<div class="summary-stats-section">
									<div class="summary-stats-row">
										<div class="stat-badge stat-blue">
											<font-awesome-icon icon="fa-solid fa-egg" size="xl" class="text-info" />
											<div class="d-flex flex-column">
												<span class="ml-1">Ingresados</span>
												<span class="ml-1 font-weight-bold stat-number">
													{{ totalResults.ingresados }}
												</span>
											</div>
										</div>
										<div class="stat-badge stat-green">
											<div class="circle-indicator circle-green"></div>
											<div class="d-flex flex-column">
												<span class="ml-1">Incubando</span>
												<span class="ml-1 font-weight-bold stat-number">
													{{ totalResults.incubando }}
												</span>
											</div>
										</div>
										<div
											class="stat-badge"
											:class="getStatTrafficLightClass(totalResults.fertilidad)"
										>
											<div class="d-flex flex-column">
												<span>Fertilidad</span>
												<span class="font-weight-bold stat-number">
													{{ totalResults.fertilidad }}
												</span>
											</div>
										</div>
										<div class="stat-badge stat-orange">
											<ChickIcon color="var(--orange)" :size="20" />
											<div class="d-flex flex-column">
												<span class="ml-1">Nacidos</span>
												<span class="ml-1 font-weight-bold stat-number">
													{{ totalResults.nacidos }}
												</span>
											</div>
										</div>
										<div class="stat-badge stat-cyan">
											<div class="circle-indicator circle-cyan"></div>
											<div class="d-flex flex-column">
												<span class="ml-1">Vivos</span>
												<span class="ml-1 font-weight-bold stat-number">
													{{ totalResults.vivos }}
												</span>
											</div>
										</div>
										<div
											class="stat-badge stat-red"
											:class="totalResults.muertos > 0 ? 'clickable' : ''"
											@click="totalResults.muertos > 0 ? openDeadsDsPie() : null"
										>
											<v-icon name="fa-skull" scale="1" class="text-danger" />
											<div class="d-flex flex-column">
												<span class="ml-1">Muertos</span>
												<span class="ml-1 font-weight-bold stat-number">
													{{ Number(totalResults.muertos) + Number(totalResults.depu_total) }}
												</span>
											</div>
										</div>
										<div
											class="stat-badge"
											:class="getStatTrafficLightClass(totalResults.efectividad)"
										>
											<div class="d-flex flex-column">
												<span>Efectividad</span>
												<span class="font-weight-bold stat-number">
													{{ totalResults.efectividad }}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<b-collapse :visible="expandedTotalSummary" id="total-summary-details">
							<div class="total-summary-content">
								<b-row>
									<!-- HUEVOS Card -->
									<b-col cols="12" md="6">
										<b-card no-body class="details-eggs-card">
											<b-card-header class="details-card-header">
												<font-awesome-icon icon="fa-solid fa-egg" size="xl" class="text-info" />
												<span class="ml-2 font-weight-bold">TOTALES - HUEVOS</span>
											</b-card-header>
											<b-card-body>
												<b-row>
													<b-col cols="12" class="mb-1">
														<div class="info-item">
															<div class="info-label">Posturas (POS)</div>
															<div class="info-value text-primary">
																{{ totalResults.posturas }}
															</div>
														</div>
													</b-col>
													<b-col cols="12" class="mb-1">
														<div class="info-item">
															<div class="info-label">Infértiles (INF)</div>
															<div class="info-value">
																{{ totalResults.infertiles }}
															</div>
														</div>
													</b-col>
													<b-col cols="12">
														<div class="info-item">
															<div class="info-label">Quemados (QUE)</div>
															<div class="info-value">
																{{ totalResults.quemados }}
															</div>
														</div>
													</b-col>
												</b-row>
											</b-card-body>
										</b-card>
									</b-col>

									<!-- POLLOS Card -->
									<b-col cols="12" md="6">
										<b-card no-body class="details-chicks-card">
											<b-card-header class="details-card-header">
												<ChickIcon color="var(--green)" :size="20" />
												<span class="ml-2 font-weight-bold">TOTALES - POLLOS</span>
											</b-card-header>
											<b-card-body>
												<b-row>
													<b-col cols="12" class="mb-1">
														<div class="info-item">
															<div class="info-label">No Nacidos (NON)</div>
															<div class="info-value">
																{{ totalResults.no_nacidos }}
															</div>
														</div>
													</b-col>
													<b-col cols="12" class="mb-1">
														<div class="info-item">
															<div class="info-label">% Incubación (% INC)</div>
															<div
																class="info-value"
																:class="getTextTrafficLightClass(totalResults.efe_infc)"
															>
																{{ totalResults.efe_infc }}
															</div>
														</div>
													</b-col>
												</b-row>
											</b-card-body>
										</b-card>
									</b-col>
								</b-row>
							</div>
						</b-collapse>
					</b-card-body>
				</b-card>
			</div>
			<div v-else class="text-center py-5">
				<p class="font-weight-bolder">NO HAY HUEVOS INGRESADO EN LOTES</p>
			</div>
		</div>

		<!-- Table View -->
		<div v-if="viewMode === 'table'" class="table-responsive">
			<b-table-simple class="position-relative" sticky-header="calc(100vh - 240px)">
				<b-thead>
					<b-tr>
						<b-th :colspan="this.postura_id ? 1 : 3" class="bg-transparent border-0" />
						<b-th
							:colspan="this.postura_id ? 3 : 4"
							class="border-white text-white text-center box-primary"
						>
							HUEVOS
						</b-th>
						<b-th
							:colspan="this.postura_id ? 5 : 6"
							class="border-white text-white text-center box-primary"
						>
							POLLOS
						</b-th>
						<b-th
							v-if="!this.postura_id"
							colspan="2"
							class="border-white text-white text-center box-primary"
						>
							FECHAS
						</b-th>
					</b-tr>
					<b-tr class="text-center">
						<template v-for="(item, key) in headTable">
							<b-th
								v-if="item.visible"
								:key="key"
								:style="{ padding: 0 }"
								class="p-1"
								:class="[key == 0 ? 'item-sticky-header' : '']"
							>
								<div class="d-flex align-items-center justify-content-center">
									<img class="icon-head-posturas" :src="item.image" alt="" />
									<p class="mb-0">
										{{ item.text }}
									</p>
								</div>
							</b-th>
						</template>
					</b-tr>
				</b-thead>

				<b-tbody>
					<template v-if="lotes.length > 0">
						<b-tr v-for="(data, index) in lotes" class="text-center" :key="index">
							<b-td
								:style="{ position: 'sticky', left: '0', backgroundColor: '#fff' }"
								class="text-center"
							>
								{{ data.code }}
								<br />
								<small v-if="!postura_id" class="text-uppercase" style="font-size: 10px !important">
									{{ data.method }}
								</small>
							</b-td>

							<b-td
								@click="clickIdLote(data)"
								v-if="!postura_id"
								class="text-center text-primary font-weight-bolder cursor-pointer"
							>
								{{ data.posturas }}
							</b-td>

							<b-td class="text-center font-weight-bolder">
								<span
									:class="data.ing != '0' ? 'clickable' : ''"
									@click="data.ing != '0' ? openEggsDetailModal(data, 'ing') : null"
								>
									{{ data.ing }}
								</span>
							</b-td>

							<b-td class="text-center">
								<span
									:class="data.inf != '0' ? 'clickable' : ''"
									@click="data.inf != '0' ? openEggsDetailModal(data, 'inf') : null"
								>
									{{ data.inf }}
								</span>
							</b-td>

							<b-td class="text-center">
								<span
									:class="data.que != '0' ? 'clickable' : ''"
									@click="data.que != '0' ? openEggsDetailModal(data, 'que') : null"
								>
									{{ data.que }}
								</span>
							</b-td>

							<b-td class="text-center font-weight-bolder">
								<span
									:class="data.inc != '0' ? 'clickable' : ''"
									@click="data.inc != '0' ? openEggsDetailModal(data, 'inc') : null"
								>
									{{ data.inc }}
								</span>
							</b-td>

							<b-td v-if="!postura_id" class="text-center">
								{{ data.stage > 2 ? data.fer : "---" }}
							</b-td>

							<b-td class="text-center">
								<span
									v-if="data.stage > 3"
									:class="data.nacidos != '0' ? 'clickable' : ''"
									@click="data.nacidos != '0' ? openEggsDetailModal(data, 'nac') : null"
								>
									{{ data.nacidos }}
								</span>
								<span v-else>---</span>
							</b-td>

							<b-td class="text-center">
								<span
									v-if="data.stage > 3"
									:class="data.no_n != '0' ? 'clickable' : ''"
									@click="data.no_n != '0' ? openEggsDetailModal(data, 'no_n') : null"
								>
									{{ data.no_n }}
								</span>
								<span v-else>---</span>
							</b-td>

							<b-td class="text-center">
								{{ data.stage > 3 ? data.efe_inc : "---" }}
							</b-td>

							<b-td class="text-center font-weight-bolder">
								<!-- <p
									class="mb-0 font-weight-bolder text-info clickable"
									@click="
										;(modalAlivesDetail.info = data),
											(modalAlivesDetail.show = !modalAlivesDetail.show)
									"
								>
									{{ data.stage > 3 ? data.vivos : "---" }}
								</p> -->
								<span v-if="data.stage > 3">
									<span class="text-secondary" v-if="data.vivos == '0'">0</span>
									<span
										class="text-info clickable"
										@click="
											;(modalAlivesDetail.info = data),
												(modalAlivesDetail.show = !modalAlivesDetail.show)
										"
										v-else
									>
										{{ data.vivos }}
									</span>
								</span>
								<span class="text-secondary" v-else>---</span>
							</b-td>

							<b-td class="text-center font-weight-bolder">
								<span v-if="data.stage > 3">
									<span class="text-secondary" v-if="data.deads_lote == '0'">0</span>
									<span
										class="text-danger clickable"
										@click="
											;(modalDeadsDetail.info = data),
												(modalDeadsDetail.show = !modalDeadsDetail.show)
										"
										v-else
									>
										{{ data.deads_lote }}
									</span>
								</span>
								<span class="text-secondary" v-else>---</span>
							</b-td>

							<b-td class="text-center font-weight-bolder">
								<span v-if="data.stage > 3">
									<span class="text-secondary" v-if="data.depu_total == '0'">0</span>
									<span
										class="text-danger clickable"
										@click="openDepurationDsPie(false, data)"
										v-else
									>
										{{ data.depu_total }}
									</span>
								</span>
								<span class="text-secondary" v-else>---</span>
							</b-td>

							<b-td v-if="!postura_id" class="text-center">
								{{ data.stage > 3 ? (data.efe ? data.efe : "---") : "---" }}
							</b-td>

							<template v-if="!postura_id">
								<b-td v-if="data.start_date" class="text-center">
									{{ data.start_date | myGlobalDayShort }}
								</b-td>

								<b-td v-else>---</b-td>
							</template>

							<template v-if="!postura_id">
								<b-td v-if="data.dob" class="text-center">
									<div>
										<div v-if="!data.dob_edit" class="d-flex align-items-center">
											<p class="mb-0">{{ data.dob }}</p>
											<div
												class="position-relative"
												v-if="
													data.stages_array
														.map((item, index) => {
															if (index == data.stages_array.length - 1) {
																return item.status_stage_lote_id
															}
														})
														.filter((it) => it != null)[0] != 3
												"
											>
												<FeatherIcon
													@click="data.dob_edit = true"
													icon="EditIcon"
													class="icon-clock cursor-pointer ml-50"
													color="orange"
												/>
											</div>
										</div>
										<div v-else>
											<date-picker
												@input="editDobLote(data.id, data.dob)"
												format="DD-MM-YYYY"
												v-model="data.dob"
												valueType="format"
												:formatter="momentFormat"
												:clearable="false"
											></date-picker>
										</div>
									</div>
								</b-td>
								<b-td v-else>---</b-td>
							</template>

							<b-td v-if="!postura_id">
								<div class="d-flex align-items-center">
									<div v-for="(stage, key) in data.stages_array" :key="key" class="position-relative">
										<StageLote
											:stage="stage"
											:stages="data.stages_array"
											:index="key"
											@open-stage="openModal(stage, data)"
										/>
										<div class="stageCommentIndicator" v-if="stage.observation"></div>
									</div>
									<FeatherIcon
										@click="clickTrackingStages(data)"
										icon="AlignJustifyIcon"
										class="cursor-pointer"
										color="orange"
										size="24"
									/>
								</div>
							</b-td>

							<b-td
								v-if="postura_id"
								class="text-center font-weight-bolder"
								:class="[data.cintillo_ala == 'COLOCADO' ? 'text-success' : 'text-warning']"
							>
								{{ data.cintillo_ala }}
							</b-td>
						</b-tr>
					</template>
					<template v-else>
						<b-tr>
							<b-td colspan="12" class="text-center">
								<p class="mb-1 mt-1 font-weight-bolder">NO HAY HUEVOS INGRESADO EN LOTES</p>
							</b-td>
						</b-tr>
					</template>
				</b-tbody>
				<b-tfoot>
					<b-tr v-if="!postura_id" class="sticky-bottom text-center text-white">
						<b-td sticky-column class="font-weight-bolder bg-dark text-white">Total</b-td>
						<b-td class="" style="background: #666262">{{ totalResults.posturas }}</b-td>
						<b-td style="background: #666262">{{ totalResults.ingresados }}</b-td>
						<b-td style="background: #666262">{{ totalResults.infertiles }}</b-td>
						<b-td style="background: #666262">{{ totalResults.quemados }}</b-td>
						<b-td style="background: #666262">{{ totalResults.incubando }}</b-td>
						<b-td style="background: #666262">{{ totalResults.fertilidad }}</b-td>
						<b-td style="background: #666262">{{ totalResults.nacidos }}</b-td>
						<b-td style="background: #666262">{{ totalResults.no_nacidos }}</b-td>
						<b-td style="background: #666262">{{ totalResults.efe_infc }}</b-td>
						<b-td style="background: #666262">{{ totalResults.vivos }}</b-td>
						<b-td style="background: #666262">
							<span
								:class="{
									'cursor-pointer': totalResults.muertos && totalResults.muertos > 0,
								}"
								@click="openDeadsDsPie"
							>
								{{ totalResults.muertos }}
							</span>
						</b-td>

						<b-td style="background: #666262">
							<span
								:class="{
									'cursor-pointer': totalResults.depu_total && totalResults.depu_total > 0,
								}"
								@click="openDepurationDsPie(true)"
							>
								{{ totalResults.depu_total }}
							</span>
						</b-td>

						<b-td style="background: #666262">{{ totalResults.efectividad }}</b-td>
						<b-td class="bg-white" colspan="3"></b-td>
					</b-tr>
				</b-tfoot>
			</b-table-simple>
		</div>

		<b-modal
			v-if="modalViewInfertiles.show && [2, 3].includes(modalViewInfertiles.stage)"
			v-model="modalViewInfertiles.show"
			size="xl"
			hide-footer
			centered
			no-close-on-backdrop
			scrollable
			modal-header-close
			header-class="modal-heade-class"
		>
			<RevisionInfertile :lote="modalViewInfertiles" @refresh="refreshLotes" />
		</b-modal>

		<b-modal
			v-if="modalViewInfertiles.show && [4].includes(modalViewInfertiles.stage)"
			v-model="modalViewInfertiles.show"
			size="xl"
			hide-footer
			centered
			no-close-on-backdrop
			scrollable
			modal-header-close
			header-class="modal-heade-class"
		>
			<RevisionNacedora :lote="modalViewInfertiles" @refresh="refreshLotes" @onlyRefresh="refreshLotes(false)"/>
		</b-modal>

		<!-- <b-modal
			v-if="modalViewInfertiles.show && [5].includes(modalViewInfertiles.stage)"
			v-model="modalViewInfertiles.show"
			size="xmd"
			hide-footer
			centered
			no-close-on-backdrop
			scrollable
			modal-header-close
			header-class="modal-heade-class"
		>
			<RevisionVaccinate :lote="modalViewInfertiles" @refresh="refreshLotes" />
		</b-modal> -->

		<b-modal
			v-if="modalViewInfertiles.show && [5].includes(modalViewInfertiles.stage)"
			v-model="modalViewInfertiles.show"
			size="xlg"
			hide-footer
			centered
			no-close-on-backdrop
			scrollable
			modal-header-close
			header-class="modal-heade-class"
		>
			<RevisionChicks :lote="modalViewInfertiles" @refresh="refreshLotes" />
		</b-modal>

		<b-modal
			v-if="modalViewPosturasByLote.show"
			v-model="modalViewPosturasByLote.show"
			:title="modalViewPosturasByLote.title"
			size="xl"
			hide-footer
		>
			<PosturasListByLote :lote="modalViewPosturasByLote" @refresh="refreshLotes" />
		</b-modal>

		<b-modal
			v-model="modalViewTrackingStagesByLote.show"
			:title="modalViewTrackingStagesByLote.title"
			hide-footer
			size="lg"
		>
			<TrackingStagesLotes :lote="modalViewTrackingStagesByLote" />
		</b-modal>
		<DeadsDetail
			:show="modalDeadsDetail.show"
			:info="modalDeadsDetail.info"
			:season="modalDeadsDetail.season"
			:is-general="modalDeadsDetail.isGeneral"
			@closing="
				modalDeadsDetail.show = false
				modalDeadsDetail.isGeneral = false
			"
		/>
		<DepurationsDetailModal
			v-if="depurationDetailModal.show"
			:info="depurationDetailModal.info"
			:season="depurationDetailModal.season"
			:is-general="depurationDetailModal.isGeneral"
			@close="
				depurationDetailModal.show = false
				depurationDetailModal.isGeneral = false
			"
		/>
		<AlivesDetail
			:show="modalAlivesDetail.show"
			:info="modalAlivesDetail.info"
			@closing="modalAlivesDetail.show = false"
		/>
		<EggsDetailModal
			:show="EggsDetailModal.show"
			:info="EggsDetailModal.info"
			:type="EggsDetailModal.type"
			@closing="EggsDetailModal.show = false"
		/>
	</div>
</template>

<script>
import { bus } from "@/main"

import loteService from "@/services/lotes.service"
import StageLote from "./components/StageLote.vue"
import RevisionInfertile from "./modals/RevisionInfertile.vue"
import RevisionNacedora from "./modals/RevisionNacedora.vue"
import RevisionVaccinate from "./modals/RevisionVaccinate.vue"
import PosturasListByLote from "./modals/PosturasListByLote.vue"
import RevisionChicks from "./modals/RevisionChicks.vue"
import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"
import moment from "moment"
import TrackingStagesLotes from "./modals/TrackingStagesLotes.vue"
import DeadsDetail from "./modals/DeadsDetail.vue"
import AlivesDetail from "./modals/AlivesDetail.vue"
import EggsDetailModal from "./modals/EggsDetailModal.vue"
import DepurationsDetailModal from "./modals/DepurationsDetailModal.vue"
import ChickIcon from "@/components/commons/Icons/ChickIcon.vue"
export default {
	name: "LotesListv2",
	components: {
		ChickIcon,
		StageLote,
		RevisionInfertile,
		RevisionNacedora,
		RevisionVaccinate,
		PosturasListByLote,
		RevisionChicks,
		DatePicker,
		TrackingStagesLotes,
		DeadsDetail,
		AlivesDetail,
		EggsDetailModal,
		DepurationsDetailModal,
	},
	props: {
		postura_id: {
			type: Number,
			default: null,
		},
		year: {
			type: Number,
			default: null,
		},
	},
	created() {
		bus.$on("reload-lotes-list", async () => {
			await this.init()
		})
	},
	destroyed() {
		bus.$off("reload-lotes-list")
	},
	async mounted() {
		await this.init()
	},
	computed: {
		totalNacidos() {
			return this.lotes.reduce(function (previousValue, currentValue) {
				return previousValue + (currentValue.stage > 3 ? parseInt(currentValue.nacidos) : 0)
			}, 0)
		},
		totalIncubando() {
			return this.lotes.reduce(function (previousValue, currentValue) {
				return previousValue + (currentValue.stage > 3 ? parseInt(currentValue.inc) : 0)
			}, 0)
		},
		totalFertilidad() {
			let count = 0
			let sum = this.lotes.reduce((act, curr) => {
				if (curr.stage > 2) {
					count++
					let [newcurr] = curr.fer.split("%")
					return act + newcurr * 1
				}
				return act
			}, 0)
			return ((sum * 1) / count).toFixed(2) + "%"
		},

		totalEfectividad() {
			let count = 0
			let sumVivos = this.lotes.reduce((act, curr) => {
				if (curr.stage > 3) {
					count++
					let vivosSum = parseInt(curr.vivos)
					let depuSum = parseInt(curr.depu_total)
					return act + (vivosSum + depuSum)
				}
				return act
			}, 0)

			let sumNacidos = this.lotes.reduce((act, curr) => {
				if (curr.stage > 3) {
					count++
					let vivosSum = parseInt(curr.nacidos)
					return act + vivosSum
				}
				return act
			}, 0)
			return ((sumVivos * 100) / sumNacidos).toFixed(2) + "%"
		},

		totalEfeInc() {
			if (this.totalIncubando) {
				return ((this.totalNacidos * 100) / this.totalIncubando).toFixed(2) + "%"
			}
			return "0.00%"
		},
	},
	data() {
		return {
			headTable: [
				{ text: "LOTE", value: "lote", visible: true },
				// { text: "MÉTODO", value: "metodo", visible: !this.postura_id },
				{
					text: "POS",
					value: "pos",
					visible: true,
					image: "/lotes/lote-grid-1.svg",
					visible: !this.postura_id,
				},
				{
					text: "ING",
					value: "ing",
					image: "/lotes/lote-grid-3.svg",
					visible: true,
				},
				{
					text: "INF",
					value: "inf",
					image: "/lotes/lote-grid-4.svg",
					visible: true,
				},
				{
					text: "QUE",
					value: "que",
					image: "/lotes/lote-grid-2.svg",
					visible: true,
				},
				{
					text: "INC",
					value: "inc",
					image: "/lotes/lote-grid-5.svg",
					visible: true,
				},
				{
					text: "FER",
					value: "fer",
					image: "/lotes/lote-grid-8.svg",
					visible: !this.postura_id,
				},
				{
					text: "NAC",
					value: "nac",
					image: "/lotes/lote-grid-5.svg",
					visible: true,
				},
				{
					text: "NON",
					value: "no_n",
					image: "/lotes/lote-grid-6.svg",
					visible: true,
				},
				{
					text: "% INC",
					value: "efe_inc",
					image: "/lotes/lote-grid-5.svg",
					visible: true,
				},
				{
					text: "VIV",
					value: "viv",
					image: "/lotes/lote-grid-7.svg",
					visible: true,
				},
				{
					text: "MUE",
					value: "mue",
					image: "/lotes/lote-grid-4.svg",
					visible: true,
				},
				{
					text: "DEP",
					value: "dep",
					image: "/lotes/lote-grid-4.svg",
					visible: true,
				},
				{
					text: "EFE",
					value: "efe",
					image: "/lotes/lote-grid-8.svg",
					visible: !this.postura_id,
				},
				{
					text: "CREACION",
					value: "creacion",
					visible: !this.postura_id,
				},
				{
					text: "NACIMIENTO",
					value: "nacimiento",
					visible: !this.postura_id,
				},
				{
					text: "ETAPAS",
					value: "etapas",
					visible: !this.postura_id,
				},
				{
					text: "CINTILLOS",
					value: "cintillos",
					visible: this.postura_id,
				},
			],
			lotes: [],
			stages: [],
			viewMode: "cards", // 'table' or 'cards'
			expandedLotes: [], // Array to track expanded lotes in cards view
			expandedTotalSummary: false, // To track expanded state of total summary card
			modalViewInfertiles: {
				show: false,
				title: "REVISION INFERTILES/QUEMADOS",
				lote_id: null,
				code: null,
				stage: null,
				status_stage_lote_id: null,
			},
			modalViewPosturasByLote: {
				show: false,
				title: "Posturas del lote",
				lote_id: null,
				code: null,
				stage: null,
			},
			modalViewTrackingStagesByLote: {
				show: false,
				title: null,
				lote_id: null,
				code: null,
				stage: null,
			},
			dobUpdateLote: "",
			momentFormat: {
				stringify: (date) => {
					return date ? moment(date).format("DD-MM-YYYY") : ""
				},
				parse: (value) => {
					return value ? moment(value, "DD-MM-YYYY").toDate() : null
				},
				getWeek: (date) => {
					return // a number
				},
			},
			searchCode: null,
			winScreen: screen.width,
			totalResults: {},
			totalPosturas: 0,
			modalDeadsDetail: { show: false, info: {}, isGeneral: false, season: null },
			depurationDetailModal: { show: false, info: {}, isGeneral: false, season: null },
			modalAlivesDetail: { show: false, info: {} },
			EggsDetailModal: { show: false, info: {}, type: "" },
		}
	},
	methods: {
		getTextTrafficLightClass(percentage) {
			const percent = percentage.replace("%", "") * 1
			if (percent >= 75) {
				return "text-success"
			} else if (percent >= 50) {
				return "text-warning"
			} else {
				return "text-danger"
			}
		},
		getStatTrafficLightClass(percentage) {
			const percent = percentage.replace("%", "") * 1
			if (percent >= 75) {
				return "stat-green"
			} else if (percent >= 50) {
				return "stat-orange"
			} else {
				return "stat-red"
			}
		},
		openDeadsDetailModal(lote) {
			this.modalDeadsDetail.info = lote
			this.modalDeadsDetail.show = true
		},
		openAlivesDetailModal(lote) {
			this.modalAlivesDetail.info = lote
			this.modalAlivesDetail.show = true
		},
		formatLoteCode(lote) {
			return lote.code.substr(3).replace(/^0+/, "")
		},
		openEggsDetailModal(data, type) {
			this.EggsDetailModal.info = data
			this.EggsDetailModal.type = type
			this.EggsDetailModal.show = true
		},
		async init() {
			this.isPreloading()
			if (this.postura_id) {
				const lotes = await loteService.getLotesByPostura({
					postura_id: this.postura_id,
				})
				this.isPreloading(false)
				this.lotes = lotes
			} else {
				let season = this.seasonFromId(this.year)
				const { lotes, posturas } = await loteService.getLotes({
					search: this.searchCode,
					start_date: season.start,
					end_date: season.end,
					// year: this.year ? season.season.slice(2, 4) : null,
				})
				this.isPreloading(false)

				this.lotes = lotes.map((item) => {
					return {
						...item,
						dob_edit: false,
					}
				})

				this.totalResults = {
					posturas: posturas,
					ingresados: lotes.reduce((a, b) => parseInt(a) + parseInt(b.ing), 0),
					infertiles: lotes.reduce(function (previousValue, currentValue) {
						return previousValue + (currentValue.stage > 1 ? parseInt(currentValue.inf) : 0)
					}, 0),
					quemados: lotes.reduce(function (previousValue, currentValue) {
						return previousValue + (currentValue.stage > 1 ? parseInt(currentValue.que) : 0)
					}, 0),
					incubando: this.totalIncubando,
					fertilidad: this.totalFertilidad,
					nacidos: this.totalNacidos,
					no_nacidos: lotes.reduce(function (previousValue, currentValue) {
						return previousValue + (currentValue.stage > 3 ? parseInt(currentValue.no_n) : 0)
					}, 0),
					efe_infc: this.totalEfeInc,
					vivos: lotes.reduce(function (previousValue, currentValue) {
						return previousValue + (currentValue.stage > 3 ? parseInt(currentValue.vivos) : 0)
					}, 0),
					muertos: lotes.reduce(function (previousValue, currentValue) {
						return previousValue + (currentValue.stage > 3 ? parseInt(currentValue.deads_lote) : 0)
					}, 0),
					depu_total: lotes.reduce(function (previousValue, currentValue) {
						return previousValue + (currentValue.stage > 3 ? parseInt(currentValue.depu_total) : 0)
					}, 0),
					efectividad: this.totalEfectividad,
				}
			}
		},
		openDeadsDsPie() {
			let season = this.seasonFromId(this.year)
			this.modalDeadsDetail.isGeneral = true
			this.modalDeadsDetail.info = {
				deads_lote: this.totalResults.muertos,
				depu_total: this.totalResults.depu_total,
			}
			this.modalDeadsDetail.season = { start: season.start, end: season.end }
			this.modalDeadsDetail.show = true
		},
		openDepurationDsPie(isGeneral, info = null) {
			let season = this.seasonFromId(this.year)
			this.depurationDetailModal.isGeneral = isGeneral
			if (isGeneral) {
				this.depurationDetailModal.info = { depu_total: this.totalResults.depu_total }
			} else {
				this.depurationDetailModal.info = info
			}
			this.depurationDetailModal.season = { start: season.start, end: season.end }
			this.depurationDetailModal.show = true
		},
		openModal(stage, lote) {
			this.modalViewInfertiles.show = true
			this.modalViewInfertiles.id = lote.id
			this.modalViewInfertiles.code = lote.code
			this.modalViewInfertiles.status_stage_lote_id = stage.status_stage_lote_id
			this.modalViewInfertiles.start_date = lote.start_date

			switch (stage.lotes_stage_order) {
				case 2:
					this.modalViewInfertiles.title = "REVISION INFERTILES/QUEMADOS"

					this.modalViewInfertiles.stage = stage.lotes_stage_order

					break
				case 3:
					this.modalViewInfertiles.title = "REVISION INFERTILES/QUEMADOS (NACEDORA)"
					this.modalViewInfertiles.stage = stage.lotes_stage_order
					break
				case 4:
					this.modalViewInfertiles.title = "REVISION DE NACIDOS / CINTILLO PATA"
					this.modalViewInfertiles.stage = stage.lotes_stage_order
					break
				// case 5:
				// 	this.modalViewInfertiles.title = "VACUNACION: VIRUELA + TRIPLE AVIAR"
				// 	this.modalViewInfertiles.stage = stage.lotes_stage_order
				// 	break
				case 5:
					this.modalViewInfertiles.title = "INGRESO DE CINTILLO ALA"
					this.modalViewInfertiles.stage = stage.lotes_stage_order
					break

				default:
					this.closeModal()
					break
			}
		},
		async refreshLotes(hasChanged = true) {
			if (hasChanged) {
				this.closeModal()
			}
			await this.init()
		},
		closeModal() {
			this.modalViewInfertiles = {
				show: false,
				title: "REVISION INFERTILES/QUEMADOS",
				lote_id: null,
				code: null,
				stage: null,
				status_stage_lote_id: null,
			}
		},
		clickIdLote(lote) {
			this.modalViewPosturasByLote.show = true
			this.modalViewPosturasByLote.lote_id = lote.id
			this.modalViewPosturasByLote.code = lote.code
			this.modalViewPosturasByLote.stage = lote.stage
			this.modalViewPosturasByLote.title = `LOTE: ${lote.code} - DETALLE DE POSTURAS`
		},
		async editDobLote(id, dob) {
			this.isPreloading()
			if (dob) {
				const resp = await loteService.updateDobByLoteId({
					dob: `${dob.split("-")[2]}-${dob.split("-")[1]}-${dob.split("-")[0]}`,
					lote_id: id,
				})
				await this.init()
			}
			this.isPreloading(false)
		},
		clickTrackingStages(lote) {
			this.modalViewTrackingStagesByLote.show = true
			this.modalViewTrackingStagesByLote.lote_id = lote.id
			this.modalViewTrackingStagesByLote.code = lote.code
			this.modalViewTrackingStagesByLote.title = `LOTE: ${lote.code} - DETALLE DE TRACKING`
		},
		toggleLoteDetails(loteId) {
			const index = this.expandedLotes.indexOf(loteId)
			if (index > -1) {
				this.expandedLotes.splice(index, 1)
			} else {
				this.expandedLotes.push(loteId)
			}
		},
		toggleTotalSummary() {
			this.expandedTotalSummary = !this.expandedTotalSummary
		},
	},
	watch: {
		async year() {
			await this.init()
		},
	},
}
</script>

<style lang="scss">
.icon-clock {
	position: absolute;
	top: -9px;
	right: -20px;
}
.item-sticky-header {
	z-index: 3 !important;
	position: sticky;
	left: 0;
	// background: red;
}
.modal-heade-class {
	background: transparent !important;
	height: 0 !important;
	position: relative;
	padding: 0;
	padding-top: 0.8rem;
	.close {
		position: absolute;
		top: 0;
		right: 0.8rem !important;
		z-index: 1;
	}
}
.sticky-lote-code {
	position: sticky;
	z-index: 1;
	left: 0;
	background: var(--dark-alpha);
}

.stageCommentIndicator {
	position: absolute;
	top: 0;
	right: 0.8rem;
	width: 1rem;
	aspect-ratio: 1;
	background: var(--primary);
	border: 2px solid #fff;
	border-radius: 50%;
}

.sticky-bottom {
	position: sticky;
	bottom: 0;
	z-index: 1020; /* Ajusta el índice z según sea necesario */
}
.box-primary {
	background: var(--primary) !important;
	border-top-left-radius: 12px;
	border-top-right-radius: 12px;
	overflow: hidden;
	margin: 2rem 0 !important;
	height: 40px;
	// display: flex;
	// align-items: center;
	padding-top: 0.7rem !important;
}

// Cards View Styles
.lotes-cards-container {
	.lote-card {
		border-radius: 12px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		transition: all 0.3s ease;
		border: 1px solid #e0e0e0;

		&:hover {
			box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
		}

		.lote-card-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 1.25rem 1.5rem;
			background: white;
			border-radius: 12px;
			transition: background 0.3s ease;

			.lote-header-left {
				display: flex;
				align-items: center;
				gap: 1rem;
				min-width: 200px;
				flex-shrink: 0;

				.lote-number-badge {
					background: var(--primary);
					color: white;
					font-weight: bold;
					font-size: 1.25rem;
					width: 50px;
					height: 50px;
					border-radius: 12px;
					display: flex;
					align-items: center;
					justify-content: center;
					box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
				}

				.lote-info {
					h4 {
						color: var(--primary);
						font-weight: 600;
						font-size: 1.25rem;
					}

					small {
						color: var(--primary);
						font-size: 0.75rem;
					}
				}
			}

			.lote-header-center {
				flex: 1;
				display: flex;
				justify-content: start;
				margin-left: 2rem;

				.stats-section-header {
					.stats-row {
						display: flex;
						gap: 0.5rem;
						flex-wrap: wrap;
						justify-content: center;

						.stat-badge {
							display: inline-flex;
							align-items: center;
							padding: 0.4rem 0.75rem;
							border-radius: 10px;
							font-weight: 600;
							font-size: 0.8rem;
							white-space: nowrap;

							.stat-number {
								font-size: 1.25rem;
							}

							.circle-indicator {
								width: 10px;
								height: 10px;
								border-radius: 50%;
								flex-shrink: 0;

								&.circle-green {
									background-color: #28c76f;
								}

								&.circle-cyan {
									background-color: #1cc7ae;
								}
							}

							&.stat-blue {
								background: rgba(0, 123, 255, 0.15);
								color: #007bff;
							}

							&.stat-green {
								background: rgba(40, 199, 111, 0.15);
								color: #28c76f;
							}

							&.stat-teal {
								background: rgba(0, 207, 232, 0.15);
								color: #00cfe8;
							}

							&.stat-cyan {
								background: rgba(28, 199, 174, 0.15);
								color: #1cc7ae;
							}

							&.stat-red {
								background: rgba(234, 84, 85, 0.15);
								color: #ea5455;
							}

							&.stat-orange {
								background: rgba(255, 159, 67, 0.15);
								color: #ff9f43;
							}

							&.stat-purple {
								background: rgba(186, 85, 211, 0.15);
								color: #ba55d3;
							}
						}
					}
				}
			}

			.lote-header-right {
				display: flex;
				align-items: center;
				gap: 1rem;

				.stages-section-header {
					padding: 0;
					display: flex;
					align-items: center;
				}

				.date-info {
					display: flex;
					gap: 1rem;
					color: var(--primary);
					width: 270px;

					small {
						display: block;
						color: var(--primary);
						font-size: 0.9rem;
						margin-bottom: 0.25rem;
					}

					.font-weight-bold {
						font-size: 1rem;
					}
				}
			}
		}

		.lote-card-content {
			padding: 1.5rem;

			.details-eggs-card {
				border: 1px solid var(--blue);
				border-radius: 8px;
				margin-bottom: 0;
				overflow: hidden;

				.details-card-header {
					background: white;
					padding: 0.75rem 1rem;
					border-bottom: 1px solid var(--blue);
					display: flex;
					justify-content: start;
					align-items: center;
					font-size: 0.95rem;
				}

				.card-body {
					padding: 1rem;
				}
			}

			.details-chicks-card {
				border: 1px solid var(--green);
				border-radius: 8px;
				margin-bottom: 0;
				overflow: hidden;

				.details-card-header {
					background: white;
					padding: 0.75rem 1rem;
					border-bottom: 1px solid var(--green);
					display: flex;
					justify-content: start;
					align-items: center;
					font-size: 0.95rem;
				}

				.card-body {
					padding: 1rem;
				}
			}

			.info-item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				.info-label {
					font-size: 0.85rem;
					color: #6c757d;
					margin-bottom: 0.5rem;
				}

				.info-value {
					font-size: 1.5rem;
					color: #2c3e50;
					font-weight: 600;

					&.clickable {
						cursor: pointer;
						transition: all 0.2s ease;

						&:hover {
							opacity: 0.8;
							text-decoration: underline;
						}
					}
				}
			}

			.lote-details-tabs {
				border-top: 1px solid #e0e0e0;
				padding-top: 1rem;

				.detail-item {
					.detail-label {
						display: flex;
						align-items: center;
						gap: 0.5rem;
						font-size: 0.85rem;
						color: #6c757d;
						margin-bottom: 0.5rem;

						.detail-icon {
							width: 20px;
							height: 20px;
							object-fit: contain;
						}
					}

					.detail-value {
						font-size: 1.1rem;
						color: #2c3e50;
						font-weight: 500;

						&.clickable {
							cursor: pointer;
							transition: all 0.2s ease;

							&:hover {
								transform: translateY(-2px);
								text-decoration: underline;
							}
						}
					}
				}
			}
		}
	}

	.total-summary-card {
		border-radius: 12px;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
		margin-top: 2rem;
		border: 1px solid #e0e0e0;

		.total-summary-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 1.25rem 1.5rem;
			background: linear-gradient(135deg, #3b4d61 0%, #4a5d73 100%);
			border-radius: 12px;
			transition: background 0.3s ease;

			.summary-header-left {
				display: flex;
				align-items: center;
				gap: 1rem;
				min-width: 200px;
				flex-shrink: 0;

				.summary-icon-badge {
					background: var(--primary);
					color: white;
					font-weight: bold;
					font-size: 1.25rem;
					width: 50px;
					height: 50px;
					border-radius: 12px;
					display: flex;
					align-items: center;
					justify-content: center;
					box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
				}

				.summary-info {
					h4 {
						color: white;
						font-weight: 600;
						font-size: 1.25rem;
					}

					small {
						color: white;
						font-size: 0.75rem;
					}
				}
			}

			.summary-header-center {
				flex: 1;
				display: flex;
				justify-content: start;
				margin-left: 2rem;

				.summary-stats-section {
					padding: 0;
					display: flex;
					justify-content: start;
					align-items: center;

					.summary-stats-row {
						display: flex;
						gap: 0.5rem;
						flex-wrap: wrap;
						justify-content: start;
						align-items: center;

						.stat-badge {
							display: inline-flex;
							align-items: center;
							padding: 0.4rem 0.75rem;
							border-radius: 10px;
							font-weight: 600;
							font-size: 0.8rem;
							white-space: nowrap;

							.stat-number {
								font-size: 1.25rem;
							}

							.circle-indicator {
								width: 10px;
								height: 10px;
								border-radius: 50%;
								flex-shrink: 0;

								&.circle-green {
									background-color: #28c76f;
								}

								&.circle-cyan {
									background-color: #1cc7ae;
								}
							}

							&.stat-blue {
								background: rgba(0, 123, 255, 0.15);
								color: #007bff;
							}

							&.stat-green {
								background: rgba(40, 199, 111, 0.15);
								color: #28c76f;
							}

							&.stat-teal {
								background: rgba(0, 207, 232, 0.15);
								color: #00cfe8;
							}

							&.stat-cyan {
								background: rgba(28, 199, 174, 0.15);
								color: #1cc7ae;
							}

							&.stat-red {
								background: rgba(234, 84, 85, 0.15);
								color: #ea5455;
							}

							&.stat-orange {
								background: rgba(255, 159, 67, 0.15);
								color: #ff9f43;
							}

							&.stat-purple {
								background: rgba(186, 85, 211, 0.15);
								color: #ba55d3;
							}

							&.clickable {
								cursor: pointer;
								transition: all 0.2s ease;

								&:hover {
									opacity: 0.8;
									transform: translateY(-1px);
								}
							}
						}
					}
				}
			}
		}

		.total-summary-content {
			padding: 1.5rem;

			.details-eggs-card {
				border: 1px solid var(--blue);
				border-radius: 8px;
				margin-bottom: 0;
				overflow: hidden;

				.details-card-header {
					background: white;
					padding: 0.75rem 1rem;
					border-bottom: 1px solid var(--blue);
					display: flex;
					justify-content: start;
					align-items: center;
					font-size: 0.95rem;
				}

				.card-body {
					padding: 1rem;
				}
			}

			.details-chicks-card {
				border: 1px solid var(--green);
				border-radius: 8px;
				margin-bottom: 0;
				overflow: hidden;

				.details-card-header {
					background: white;
					padding: 0.75rem 1rem;
					border-bottom: 1px solid var(--green);
					display: flex;
					justify-content: start;
					align-items: center;
					font-size: 0.95rem;
				}

				.card-body {
					padding: 1rem;
				}
			}

			.info-item {
				display: flex;
				justify-content: space-between;
				align-items: center;

				.info-label {
					font-size: 0.85rem;
					color: #6c757d;
					margin-bottom: 0.5rem;
				}

				.info-value {
					font-size: 1.5rem;
					color: #2c3e50;
					font-weight: 600;

					&.clickable {
						cursor: pointer;
						transition: all 0.2s ease;

						&:hover {
							opacity: 0.8;
							text-decoration: underline;
						}
					}
				}
			}
		}
	}
}

.clickable {
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		opacity: 0.8;
	}
}

@media (max-width: 1700px) {
	.lotes-cards-container {
		.lote-card {
			.lote-card-header {
				display: grid;
				grid-template-columns: auto 1fr;
				grid-template-rows: auto auto;
				gap: 1rem;
				align-items: start;

				.lote-header-left {
					grid-column: 1;
					grid-row: 1;
				}

				.lote-header-center {
					grid-column: 2;
					grid-row: 1;
					margin-left: 2rem;
					width: auto;

					.stats-section-header {
						.stats-row {
							justify-content: flex-start;
							gap: 0.4rem;
						}
					}
				}

				.lote-header-right {
					grid-column: 1 / -1;
					grid-row: 2;
					width: 100%;
					justify-content: space-between;
					align-items: stretch;
					gap: 0.75rem;

					.date-info {
						order: 1;
						align-self: flex-start;
					}

					.stages-section-header {
						order: 2;
						align-self: flex-start;
					}
				}
			}
		}

		.total-summary-card {
			.total-summary-header {
				display: grid;
				grid-template-columns: auto 1fr;
				grid-template-rows: auto;
				gap: 1rem;
				align-items: start;

				.summary-header-left {
					grid-column: 1;
					grid-row: 1;
				}

				.summary-header-center {
					grid-column: 2;
					grid-row: 1;
					margin-left: 2rem;
					width: auto;

					.summary-stats-section {
						.summary-stats-row {
							justify-content: flex-start;
							gap: 0.4rem;
						}
					}
				}
			}
		}
	}
}

@media (max-width: 1200px) {
	.lotes-cards-container {
		.lote-card {
			.lote-card-header {
				display: grid;
				grid-template-columns: 1fr;
				grid-template-rows: auto auto auto;
				gap: 1rem;

				.lote-header-left {
					grid-column: 1;
					grid-row: 1;
					width: 100%;
				}

				.lote-header-center {
					grid-column: 1;
					grid-row: 2;
					width: 100%;
					margin-left: 0;
				}

				.lote-header-right {
					grid-column: 1;
					grid-row: 3;
					width: 100%;
				}
			}
		}

		.total-summary-card {
			.total-summary-header {
				display: grid;
				grid-template-columns: auto;
				grid-template-rows: auto auto;
				gap: 1rem;

				.summary-header-left {
					grid-column: 1;
					grid-row: 1;
					width: 100%;
				}

				.summary-header-center {
					grid-column: 1;
					grid-row: 2;
					width: 100%;
					margin-left: 0;

					.summary-stats-section {
						.summary-stats-row {
							justify-content: flex-start;
							gap: 0.4rem;
						}
					}
				}
			}
		}
	}
}

@media (max-width: 700px) {
	.lotes-cards-container {
		.lote-card {
			.lote-card-header {
				.lote-header-right {
					flex-direction: column;
					align-items: stretch;
					gap: 0.75rem;

					.date-info {
						order: 1;
						align-self: flex-start;
					}

					.stages-section-header {
						order: 2;
						align-self: flex-start;
					}
				}
			}
		}
	}
}
</style>
